define.alias("shared/components/shared/profile-timezone-select", "calendar/components/shared/profile-timezone-select");